import { render, staticRenderFns } from "./ApiLoadingCircular.vue?vue&type=template&id=4f05c80c&scoped=true"
import script from "./ApiLoadingCircular.vue?vue&type=script&lang=js"
export * from "./ApiLoadingCircular.vue?vue&type=script&lang=js"
import style0 from "./ApiLoadingCircular.vue?vue&type=style&index=0&id=4f05c80c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f05c80c",
  null
  
)

export default component.exports